export const getFileSetIds = (isSelectAll, activeImg, fileSets) => {
  if (!isSelectAll) {
    return activeImg.map(x => fileSets[x].fileSetId).join(',');
  }

  return fileSets.map(item => item.fileSetId).join(',');
};
